// @ts-nocheck
import * as Types from "../../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type DeleteWorkbookResultsMutationVariables = Types.Exact<{
  variantId: Types.Scalars["ID"]["input"];
  parameterSetsSelected: Types.Scalars["Boolean"]["input"];
}>;

export type DeleteWorkbookResultsMutation = {
  __typename?: "Mutation";
  deleteWorkbookResults?: {
    __typename?: "DeleteWorkbookResultsPayload";
    workbookId: string;
  } | null;
};

export const DeleteWorkbookResultsDocument = gql`
  mutation DeleteWorkbookResults(
    $variantId: ID!
    $parameterSetsSelected: Boolean!
  ) {
    deleteWorkbookResults(
      variantId: $variantId
      parameterSetsSelected: $parameterSetsSelected
    ) {
      workbookId
    }
  }
`;
export type DeleteWorkbookResultsMutationFn = Apollo.MutationFunction<
  DeleteWorkbookResultsMutation,
  DeleteWorkbookResultsMutationVariables
>;

/**
 * __useDeleteWorkbookResultsMutation__
 *
 * To run a mutation, you first call `useDeleteWorkbookResultsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorkbookResultsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWorkbookResultsMutation, { data, loading, error }] = useDeleteWorkbookResultsMutation({
 *   variables: {
 *      variantId: // value for 'variantId'
 *      parameterSetsSelected: // value for 'parameterSetsSelected'
 *   },
 * });
 */
export function useDeleteWorkbookResultsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteWorkbookResultsMutation,
    DeleteWorkbookResultsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteWorkbookResultsMutation,
    DeleteWorkbookResultsMutationVariables
  >(DeleteWorkbookResultsDocument, options);
}
export type DeleteWorkbookResultsMutationHookResult = ReturnType<
  typeof useDeleteWorkbookResultsMutation
>;
export type DeleteWorkbookResultsMutationResult =
  Apollo.MutationResult<DeleteWorkbookResultsMutation>;
export type DeleteWorkbookResultsMutationOptions = Apollo.BaseMutationOptions<
  DeleteWorkbookResultsMutation,
  DeleteWorkbookResultsMutationVariables
>;
